// extracted by mini-css-extract-plugin
module.exports = {"root":"features_root__1jvQs","extraSmall":"features_extraSmall__2zB4b","extraWide":"features_extraWide__3moQX"};